import { Injectable } from '@angular/core';
import { LoadingService } from '../shared/loading';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'jquery';
import moment from 'moment';
import { tap } from 'rxjs/operators';
import { Reminder } from '../reminder/store';
import { LoggingService } from '../shared/services/logging';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PayrateOverrideService {
    private uri = `${environment.apiLocation}/EmployeePayOvr`;
    constructor(private http: HttpClient, protected log: LoggingService) {}
    public recalcRates(
        startDate: string,
        endDate: string
    ): Observable<unknown> {
        this.log.verbose({
            type: 'PayrateOverrideService:recalcRates',
            startDate,
            endDate
        });
        return this.http.post<unknown>(`${this.uri}/RecalcHourlyRates`, {
            StartDate: startDate,
            EndDate: endDate
        });
        // .pipe(result => {
        //     this.log.verbose({
        //         type: 'PayrateOverrideService:recalcRates',
        //         result
        //     });
        // });
    }
}
